import { useEffect, useRef } from 'react';

const useHeaderAutoFocus = (expanded, saved) => {
  const actionRef = useRef(null);
  const headingRef = useRef(null);
  useEffect(() => {
    if (expanded) {
      if (saved) {
        if (actionRef && actionRef.current) {
          actionRef.current.focus({ preventScroll: true });
        }
      } else if (headingRef && headingRef.current) {
        headingRef.current.focus({ preventScroll: true });
      }
    }
  }, [expanded, saved]);
  return [headingRef, actionRef];
};

export default useHeaderAutoFocus;
